
import { Elite } from '@components';

export function ElitePage() {
  return (
    <div className="brio-rci-how-to-page" style={{ flex: 1 }}>
      <Elite />
    </div>
  );
}
